import { combineReducers } from "redux";
import { authReducer } from "../Components/Auth/authReducer";
import { accountReducer } from "../Components/Account/redux/AccountReducer";
import { insightsApi } from "../features/insights/api";
import { assetMonitoringApi } from "../features/asset-monitoring/api";

export const RootReducer = combineReducers({
  auth: authReducer,
  accounts: accountReducer,
  [insightsApi.reducerPath]: insightsApi.reducer,
  [assetMonitoringApi.reducerPath]: assetMonitoringApi.reducer,
});
